import { CONFIG_ENV } from './env';

export const curentEnv = CONFIG_ENV;

export const isLocal =
  (typeof window !== 'undefined' && window.location.hostname === 'localhost') ||
  (typeof process !== 'undefined' && CONFIG_ENV === 'local');

// running app locally, but using development API
export const isLocalDev = CONFIG_ENV === 'development' && isLocal;

export const isDevelopment = CONFIG_ENV === 'development';

// running app locally, but using staging API
export const isLocalStaging = CONFIG_ENV === 'staging' && isLocal;

export const isStaging = CONFIG_ENV === 'staging';

export const isProd = CONFIG_ENV === 'production';

export const isQa = CONFIG_ENV === 'qa';

export const isQaFe = CONFIG_ENV === 'qa-fe';

export const THIRD_PARTY_TRACKING_ENDABLED = isProd;

export const IS_STORYBOOK = process.env.STORYBOOK === 'true';
export const ADMIN_DISABLE_SUB_CANCEL_REASON = isLocal; // why only local?
export const ADMIN_LANE_DELETE_ENABLED = isLocal;
export const ENABLE_RUM = isProd;
export const DISPLAY_ONBOARIND_PERCENT_ENTERPRISE = isDevelopment || isLocal;
export const FILTER_UNUSED_OPERATORS = isProd;
export const QA_SITE_SURVEY_ADDRESS_ARRAY = [
  { address: '1314 7th St, Santa Monica, CA 90401', lat: 34.020101, lng: -118.49326555 },
  { address: '501 Broadway, Nashville, TN 37203', lat: 36.16346979558982, lng: -86.76171840911704 },
  {
    address: '500 E 1st St, Fort Worth, TX 76102',
    lat: 32.75806276721787,
    lng: -97.32930948452254,
  },
  {
    address: '2535 Rivard St, Detroit, MI 48207',
    lat: 42.345383878266865,
    lng: -83.04229802083397,
  },
  { address: '1770 13th St, Boulder, CO 80302', lat: 40.015055, lng: -105.2799799 },
  { address: '298 Gough St, San Francisco, CA 94102', lat: 37.77603, lng: -122.42258 },
  { address: '227 W 27th St, New York, NY 10001', lat: 40.74664916488252, lng: -73.99421431831814 },
];
export const ENABLE_SHARED_EXITS_CONFIG = isDevelopment || isLocal;
export const SHOW_REACT_HOOK_FORM_DEV_TOOLS = isLocal;
export const SHOW_NEW_CHARGE_INVOICE_MODAL = isLocal;
export const DONT_VERIFY_OPERATING_GROUP = !isProd;
export const FILTER_OPERATING_GROUP_IN_LOCATION_GROUP = isProd || isLocal;
export const MAINTENANCE_MODE = false;
export const SHOW_INDIVIDUAL_SUBSCRIPTION_TABLE = !isProd;
export const SHOW_ARCHIVE_SURVEY = !isProd;
export const ENABLE_EXPRESS_CHECKOUT = !isProd;
export const ENABLE_ENFORCEMENT_PLAN_ESCALATION_EDITOR = !isProd;

export const ENABLE_RESERVATION_VERIFICATION = isDevelopment;
export const USE_MAPBOX_FOR_SITE_SEARCH = isProd || isStaging || isLocal;
export const SHOW_CONSUMER_ACTIVITY_IN_NAV = !isProd;
export const LOCAL_DISPLAY_SUBSCRIPTION_SALE_IN_CONSUMER_APP = !isProd;
// Feature flag name for tabular validation
export const TABULAR_VALIDATION_FLAG = isDevelopment || isLocal;

export const Flags = {
  ADMIN_DISABLE_SUB_CANCEL_REASON,
  ADMIN_LANE_DELETE_ENABLED,
  ENABLE_RUM,
  DISPLAY_ONBOARIND_PERCENT_ENTERPRISE,
  QA_SITE_SURVEY_ADDRESS_ARRAY,
  THIRD_PARTY_TRACKING_ENDABLED,
  SHOW_REACT_HOOK_FORM_DEV_TOOLS,
  DONT_VERIFY_OPERATING_GROUP,
  ENABLE_EXPRESS_CHECKOUT,
  SHOW_CONSUMER_ACTIVITY_IN_NAV,
  TABULAR_VALIDATION_FLAG,
};
